import IPathModel from 'Models/PathModel'
import VisitsPaths from './VisitsPaths'
import VisitsPage from 'Application/Visits/Pages/Visits/VisitsPage'
import NewVisitPage from '../Pages/NewVisit/NewVisitPage'
import VisitPage from '../Pages/VisitPage/VisitPage'
import FinalPage from '../Pages/NewVisit/FinalPage'
import FakeNewVisitPage from '../Pages/NewVisit/FakeNewVisitPage'
import IncompleteDocumentationPage from '../Pages/IncompleteDocumentation/IncompleteDocumentationPage'
import SendToServerPage from '../Pages/NewVisit/SendToServerPage'
import EditVisits from '../Pages/Visits/EditVisits'
import DispatchPage from '../Pages/VisitPage/DispatchPage'
import RefrencePage from '../Pages/VisitPage/RefrencePage'

const VisitsRoutes: IPathModel[] = [
  {
    path: VisitsPaths.VisitsMain,
    element: VisitsPage,
  },
  {
    path: VisitsPaths.VisitPage,
    element: VisitPage,
    params: ['visitId'],
  },
  {
    path: VisitsPaths.NewVisit,
    element: NewVisitPage,
  },
  {
    path: VisitsPaths.NewVisitFinalPage,
    element: FinalPage,
  },
  {
    path: VisitsPaths.FakeNewVisit,
    element: FakeNewVisitPage,
  },
  {
    path: VisitsPaths.IncompleteDocumentationPage,
    element: IncompleteDocumentationPage,
    params: ['visitId'],
  },
  {
    path: VisitsPaths.SendToServerPage,
    element: SendToServerPage,
  },
  {
    path: VisitsPaths.VisitsEdit,
    element: EditVisits,
    params: ['visitId'],
  },
  {
    path: VisitsPaths.DispatchPage,
    element: DispatchPage,
    params: ['Id'],
  },
  {
    path: VisitsPaths.RefrencePage,
    element: RefrencePage,
    params: ['Id'],
  },
]

export default VisitsRoutes
